<button
  mat-raised-button 
  [type]="buttonType"
  [disabled]="disabled"
  [class]="className"
  color="ruleType"
  (click)="onClick()">{{ buttonText | i18n}}</button>
